import HSPClinicSchedule from "./HSPClinicSchedule";

export default HSPClinicSchedule;
